import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from '../../contexts/auth';

const Home: React.FC = () => {
  const [{ isAuthenticated }] = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!isAuthenticated) {
      history.push('/login');
    }
  }, [history, isAuthenticated]);

  return (
    <div>
      <h1>The Portal</h1>
    </div>
  );
}

export default Home;
